<template>
  <div>
    <div class="sac__font-18 med">
      Overall Performance Rating
    </div>
    <div class="card-wrap">
      <div class="flex-row flex-1 card align-start">
        <div class="flex-column">
          <div class="sac__font-16 med n60 center">
            Breakdown Risk
          </div>
          <img
            v-if="imgSrc"
            :src="imgSrc"
            alt="rating"
            class="breakdown-img"
          />
        </div>
        <div class="flex-column margin-left-120">
          <div class="sac__font-16 med n60">
            Contributing Risk Factors
          </div>
          <div v-for="(rec, idx) in risksList" :key="idx">
            <div class="grid-column ai-c jc-s margin-top-8">
              <span
                :class="[
                  'risk-pill',
                  rec?.level?.toLowerCase() === 'low' ? 'green-pill' : '',
                  rec?.level?.toLowerCase() === 'medium' ? 'yellow-pill' : '',
                  rec?.level?.toLowerCase() === 'high' ? 'red-pill' : '',
                ]"
              >
                {{ rec.level?.toLowerCase() === 'medium' ? 'Med' : rec.level }}
              </span>
              <span class="sac__font-16 n60 ml-2">
                {{ rec.label }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="isBreakdownRiskUnavailable"
        class="card-unavailable-scrim"
        role="status"
      >
        <span class="sac__font-16 med n60 card-unavailable-msg">
          Breakdown risk is unavailable due to missing/incomplete profile
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import riskLowDownImg from '@shared/assets/img/performance-summary/risk-low-down.png';
import riskLowUpImg from '@shared/assets/img/performance-summary/risk-low-up.png';
import riskMedDownImg from '@shared/assets/img/performance-summary/risk-med-down.png';
import riskMedUpImg from '@shared/assets/img/performance-summary/risk-med-up.png';
import riskHighImg from '@shared/assets/img/performance-summary/risk-high.png';

export default {
  name: 'PerformanceRating',
  computed: {
    ...mapState({
      selectedUnit: (state) => state.customerDetail.selectedUnit,
    }),
    isBreakdownRiskUnavailable() {
      const { selectedUnit } = this;
      if (!selectedUnit || typeof selectedUnit !== 'object') {
        return false;
      }
      return !selectedUnit.profileCompletedDate;
    },
    risksList() {
      const { risks } = this.selectedUnit || {};
      return Array.isArray(risks) ? risks : [];
    },
    imgSrc() {
      const {
        breakdownRiskScore: score,
      } = this.selectedUnit || {};
      if (score <= 7) {
        if (score < 4) {
          return riskLowDownImg;
        }
        return riskLowUpImg;
      } if (score > 7 && score <= 17.50) {
        if (score < 12) {
          return riskMedDownImg;
        }
        return riskMedUpImg;
      }
      return riskHighImg;
    },
  },
};
</script>

<style scoped lang="scss">
.card-wrap {
  position: relative;
}

.card-unavailable-scrim {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  text-align: center;
  background-color: $N5;
  border-radius: 8px;
  pointer-events: auto;
}

.card-unavailable-msg {
  max-width: 28rem;
}

.card {
  background-color: $N5;
  border-radius: 8px;
  padding: 2rem;
  align-items: center;
  justify-content: center;
  .breakdown-img {
    width: 340px;
    height: 300px;
    object-fit: contain;
  }
  .risk-pill {
    width: 52px;
    height: 20px;
    border: 1px solid;
    border-radius: 9px;
    text-align: center;
    font-size: 12px;
    font-weight: 600;
    &.green-pill {
      background-color: #E1FFE8;
      border-color: #00AB3C;
      color: #00AB3C;
    }
    &.yellow-pill {
      background-color: #FFF2D9;
      border-color: #FFAB00;
      color: #FFAB00;
    }
    &.red-pill {
      background-color: #FFEAEB;
      border-color: #EB0A0E;
      color: #EB0A0E;
    }
  }
}
</style>
